import React from 'react';
import { Navigation, DecedentRoutes } from '@/pages/admin-panel/components/index';
import { Route, routes } from '@/app/routing/index';
import { Switch } from 'react-router-dom';
import AdminAccessCodes from '@/pages/admin-access-codes/index';
import AdminResellers from '@/pages/admin-resellers/index';
import AdminResellerForm from '@/pages/admin-reseller-form/index';
import ErrorBoundary from '@/common/components/ErrorBoundary';

const AdminPanel = () => {
  return (
    <main className="dashboardContainer">
      <Navigation />
      <section className="dashboardContainerContent">
        <ErrorBoundary>
          <Switch>
            <Route
              path={routes.adminPanel.accessCodes}
              component={AdminAccessCodes}
              auth
              exact
            />
            <Route
              path={routes.adminPanel.resellerNew}
              component={AdminResellerForm}
              auth
              exact
            />
            <Route
              path={routes.adminPanel.resellerEdit}
              component={AdminResellerForm}
              auth
              exact
            />
            <Route
              path={routes.adminPanel.resellers}
              component={AdminResellers}
              auth
              exact
            />
            <Route
              path={routes.adminPanel.decedents}
              component={DecedentRoutes}
              auth
            />
          </Switch>
        </ErrorBoundary>
      </section>
    </main>
  );
};

export default AdminPanel;
